import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useGetCoopQuery } from "../store/auth/authApi";
import { setCoopData, setCompanyId } from "../store/auth/index";
import { persistThemeFromCoopPayload } from "../theme/companyTheme";

/**
 * Load cooperative branding for public investor auth pages from the current host.
 */
export function usePublicInvestorCompany() {
  const dispatch = useDispatch();
  const [fullhost, setFullhost] = useState("");

  useEffect(() => {
    setFullhost(window.location.host);
  }, []);

  const {
    data: coopData,
    isLoading: isLoadingCoop,
    isSuccess: isCoopSuccess,
    isError: isCoopError,
  } = useGetCoopQuery({ domain_url: fullhost }, { skip: !fullhost });

  const companyDetails = coopData?.data;
  const companyId = companyDetails?.company_id;

  useEffect(() => {
    if (isCoopSuccess && companyDetails) {
      dispatch(setCoopData(companyDetails));
      dispatch(setCompanyId(companyId));
      persistThemeFromCoopPayload(companyDetails);
    }
  }, [isCoopSuccess, companyDetails, companyId, dispatch]);

  return {
    fullhost,
    companyDetails,
    companyId,
    isLoadingCoop,
    isCoopError,
    isCoopSuccess,
  };
}
